exports.textToB64 = (str) => {
  const toB64 = window.btoa(str);
  return `data:text/csv;base64,${toB64}`;
};
